import React, { useState } from "react"
import FormHeaderProject from "./controllers/FormHeaderProject.controller"
import FormProject from "./controllers/projectForm/FormProject.controller"
import { FORM_CLIENT_MODE } from "../../consts/modules/clients.consts"

const ProjectForm = () => {
  const [mode, setMode] = useState(FORM_CLIENT_MODE.CREATE)
  return (
    <div id="edit-project-form-view">
      <FormHeaderProject setMode={setMode} />
      <FormProject mode={mode} />
    </div>
  )
}

export default ProjectForm
